// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".section-overlay__wrapper[data-v-5ca6c48c]{-ms-overflow-style:none;scrollbar-width:none;}.section-overlay__wrapper[data-v-5ca6c48c]::-webkit-scrollbar{display:none}.header-not-visible .section-overlay[data-v-5ca6c48c]{margin-top:96px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
